import { Button } from "@mui/material";
import { CalendarPlus, Plus } from "lucide-react";
import { useStore } from "../../../../helpers";
import { observer } from "mobx-react-lite";

interface NotebookHeaderProps {
  onAddContext: (notebookId: number) => void;
  onAddSource: (parentId: string | null, parentLabel: string) => void;
}

const headerButtonSx = {
    textTransform: "none",
    minWidth: 0,
    fontSize: 14,
    color: "black",
    borderColor: "black",
    transition:
        "background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease",
    transitionDelay: "100ms",
    "&:hover": {
        backgroundColor: "#8DE038",
        color: "black",
        borderColor: "transparent",
    },
};

const NotebookHeader = observer(({ onAddContext, onAddSource }: NotebookHeaderProps) => {
    const { tarsStore } = useStore();
    const notebook = tarsStore.selectedNotebook;

    return (
        <div className="border-b border-[#CDCDCD] bg-white px-4 py-4 prototype--content">
            <h2 className="mb-4 truncate text-[20px] font-bold text-black">
                {notebook?.name}
            </h2>

            <div className="flex flex-row flex-nowrap items-center gap-2">
                <Button
                    variant="outlined"
                    onClick={() => notebook && onAddContext(notebook.id)}
                    sx={headerButtonSx}
                    startIcon={<CalendarPlus size={18} strokeWidth={2.5} />}
                >
                    Add Context
                </Button>

                <Button
                    variant="outlined"
                    onClick={() => onAddSource(null, "Root")}
                    sx={headerButtonSx}
                    startIcon={<Plus size={18} strokeWidth={2.5} />}
                >
                    Add Source
                </Button>
            </div>
        </div>
    );
});

export default NotebookHeader;
